import styles from "./experiences.module.css";

const Experiences = () => {
  const data = [
    {
      id: 0,
      title: "Wordpress Developer",
      cname: "Karensa Team",
      from: "January 2014",
      until: "September 2015",
      text: "Build and develop WordPress themes and plugins for various projects that are all done with WordPress. Build multiple theme management panels and plugins to control the theme.",
    },
    {
      id: 1,
      title: "Freelance Software Developer",
      cname: "Freelance",
      from: "September 2015 ",
      until: "January 2021",
      text: `<p>During this time, I did many freelance activities. I was more into web development and I was more interested in doing Back-End work. You can see a summary of these activities in the following list:</p>
      <ul>
      <li>Create Back-End systems for many projects ( Node.JS - Laravel - Golang - WordPress )</li>
      <li>Create Front-End for projects ( React.JS )</li>
      <li>Full-Stack web development</li>
      <li>Data manipulating applications &amp; some "data science" works</li>
      <li>WordPress Plugin and Theme Development ( until 2018 )</li>
      </ul>`,
    },
    {
      id: 2,
      title: "IT Manager & Software Developer",
      cname: "USERN",
      from: "January 2020",
      until: "Peresent",
      text: `<p>At USERN, I work as an IT manager and manage most of the activities related to this department, as well as software development and web development, and when other departments need programming services, I do it. It's my responsibility.<br />What I have done so far at USERN:</p>
      <ul>
      <li>Create some data manipulating applications ( Python &amp; Golang )</li>
      <li>Create "Scopus" data scrapper application ( Python )</li>
      <li>Fixed USERN website issues ( Angular )</li>
      <li>Doing Some Full-Stack Web activities - new FrontEnd &amp; BackEnd ( React.js - In Progress )</li>
      <li>Create USERN Congress Website ( WordPress )</li>
      </ul>`,
    },
    {
      id: 3,
      title: "Freelance ML/DL-CV-NLP Developer",
      cname: "Freelance",
      from: "January 2022",
      until: "Peresent",
      text: `<p>As a computer science student, I did projects for Deep Learning, Computer Vision , and Natural Language Processing as a freelancer. Because it helped me challenge myself, which I think is the best way to learn while studying.</p>`,
    },
  ];

  const list = data.reverse().map((item) => {
    return (
      <div key={item.id} className={styles.item}>
        <div className={styles.id}>{item.id}</div>
        <div className={styles.header}>
          <div className={`${styles.title} w-full lg:w-3/6`}>{item.title}</div>
          <div className={`${styles.date} w-full lg:w-3/6 lg:text-right`}>
            {item.from} - {item.until}
          </div>
          <div className={styles.cname}>{item.cname}</div>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: item.text }}
          className={styles.text}
        ></div>
      </div>
    );
  });

  return <div className={styles.box}>{list}<div className={styles.idz}><i className={`fal fa-rocket-launch`}></i></div></div>;
};

export default Experiences;
